import React from 'react';

type NoDataMessageProps = {
    id: string;
    buttonText?: string;
    message: string;
    buttonAction?: () => void;
    width?: string;
};

const NoDataMessage = ({id, buttonText, message, buttonAction, width = 'full' }: NoDataMessageProps) => {
    return (
        <div 
            id={id}
            className={`tw-rounded tw-text-center tw-bg-[#fff] tw-justify-end tw-box-border ${width === 'full' ? 'tw-w-full' : 'tw-w-[776px]'} tw-h-[262px] tw-border-[2px] tw-border-solid tw-border-[#f4f4f7]`} 
        >
            <div id={`${id}-content`} className='tw-flex tw-justify-center'>
                <div id={`${id}-card`} className='tw-mx-7 tw-rounded tw-bg-[#fff] tw-box-border tw-w-[716px] tw-h-[104px] tw-border-[2px] tw-border-solid border-[#f4f4f7] tw-mt-7'>
                    <div id={`${id}-header`} className='tw-rounded-t tw-rounded-b-none tw-bg-[#e4e4e8] tw-w-[712px] tw-h-[38px]' />
                    <div id={`${id}-placeholder-row`} className='tw-flex tw-justify-between tw-py-2.5 tw-px-2.5 tw-gap-2'>
                        <div id={`${id}-placeholder-main`} className='tw-rounded tw-bg-[#f4f4f7] tw-w-[410px] tw-py-2 tw-px-2.5 tw-box-border'/>
                        <div id={`${id}-placeholder-secondary`} className="tw-w-[163px] tw-h-[36px] tw-px-2.5 tw-py-2 tw-bg-gray-100 tw-rounded" />
                        <div id={`${id}-placeholder-tertiary`} className="tw-w-[78px] tw-h-[36px] tw-px-2.5 tw-py-2 tw-bg-gray-100 tw-rounded" />
                    </div>      
                    <div id={`${id}-message-section`} className='tw-flex tw-flex-col tw-items-center tw-mt-6'>
                        <label 
                            id={`${id}-message-text`}
                            className="tw-text-xl tw-font-semibold tw-text-slategray tw-text-center tw-inline-block"
                        >
                            {message}
                        </label>
                        {buttonText ? 
                            <button 
                                id={`${id}-action-btn`}
                                className={`button-style tw-mt-6`} 
                                onClick={buttonAction}
                            >
                                {buttonText}
                            </button> 
                        : null}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NoDataMessage;